import BeechLeaf from '../../assets/sid/BeechLeaf.png';
import CherryLeaf from '../../assets/sid/CherryLeaf.png';
import LiriodendronLeaf from '../../assets/sid/LiriodendronLeaf.png';
import RedMapleLeaf from '../../assets/sid/RedMapleLeaf.png';
import RedbudLeaf from '../../assets/sid/RedbudLeaf.png';
import SassafrasLeaf from '../../assets/sid/SassafrasMittenLeaf.png';
import ShagbarkHickoryLeaf from '../../assets/sid/ShagbarkHickoryLeaf.png';
import WhiteOakLeaf from '../../assets/sid/WhiteOakLeaf.png';
import WhitePineLeaf from '../../assets/sid/WhitePineLeaf.png';

export type Species = {
  id: string;
  name: string;
  code: string;
  count: number;
  leafImage: string;
  keyImage: string;
};

export const speciesList: Species[] = [
  {
    id: 'white-oak',
    name: 'White Oak',
    code: 'WO',
    count: 3,
    leafImage: WhiteOakLeaf,
    keyImage: WhiteOakLeaf,
  },
  {
    id: 'red-maple',
    name: 'Red Maple',
    code: 'RM',
    count: 6,
    leafImage: RedMapleLeaf,
    keyImage: RedMapleLeaf,
  },
  {
    id: 'tulip-tree',
    name: 'Tulip Tree',
    code: 'TT',
    count: 4,
    leafImage: LiriodendronLeaf,
    keyImage: LiriodendronLeaf,
  },
  {
    id: 'sassafras',
    name: 'Sassafras',
    code: 'SA',
    count: 2,
    leafImage: SassafrasLeaf,
    keyImage: SassafrasLeaf,
  },
  {
    id: 'hickory',
    name: 'Hickory',
    code: 'HI',
    count: 1,
    leafImage: ShagbarkHickoryLeaf,
    keyImage: ShagbarkHickoryLeaf,
  },
  {
    id: 'redbud',
    name: 'Redbud',
    code: 'RB',
    count: 2,
    leafImage: RedbudLeaf,
    keyImage: RedbudLeaf,
  },
  {
    id: 'beech',
    name: 'Beech',
    code: 'BE',
    count: 3,
    leafImage: BeechLeaf,
    keyImage: BeechLeaf,
  },
  {
    id: 'cherry',
    name: 'Cherry',
    code: 'CH',
    count: 5,
    leafImage: CherryLeaf,
    keyImage: CherryLeaf,
  },
  {
    id: 'white-pine',
    name: 'White Pine',
    code: 'WP',
    count: 1,
    leafImage: WhitePineLeaf,
    keyImage: WhitePineLeaf,
  },
];

export const totalLeaves = speciesList.reduce((sum, s) => sum + s.count, 0);

export const calculateSid = (counts: Record<string, number>): { n: number; sumNn1: number; sid: number } => {
  const n = Object.values(counts).reduce((sum, v) => sum + v, 0);
  const sumNn1 = Object.values(counts).reduce((sum, v) => sum + v * (v - 1), 0);
  const sid = n > 1 ? 1 - sumNn1 / (n * (n - 1)) : 0;
  return { n, sumNn1, sid };
};
